import React, {useState} from 'react'
import {GatsbyImage} from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'
import Arrow from '../assets/images/landing-arrow.png'
import Select from 'react-select';
import {navigate} from "gatsby";
import Link from '../utils/link'

const options = [
    { value: '/service/home-loans/', label: "Buy my first home" },
    { value: '/service/wellness/', label: "Refinance my loan"},
    { value: '/service/home-loans/', label: "Upgrade my home" },
    { value: '/service/investment-loans/', label: "Buy an investment property" },
    { value: '/service/commercial-loans/', label: "Buy a commercial property" },
    { value: '/service/car-loans/', label: "Buy a car" },
    { value: '/service/personal-loans/', label: "Get a personal loan " },
];

const LandingBanner = ({image, video, title, showSearch, link}) => {
  const [selectedOption, setSelectedOption] = useState(options[0]);

  const handle = (e) => {
    navigate(selectedOption.value)
  }

  return (
    <section className='landing-banner'>
      <div className='landing-banner__bg'>
        {image && <GatsbyImage image={image?.localFile?.childImageSharp?.gatsbyImageData}
                               alt={image.altText ? image.altText : 'Heart Financial'}/>}
        {video && <video autoPlay muted loop playsInline src={video}/>}
      </div>
      <Fade bottom distance='30px'>
        <div className='landing-banner__inner'>
          <div className='landing-banner__content' data-sal='fade' data-sal-duration='1000' data-sal-delay='0'
               data-sal-easing='ease'>
            <h1>{parse(title)}</h1>
            <img loading='lazy' className='arrow' src={Arrow} alt="arrow"/>
            { link && <Link to={link} className='landing-banner__link' /> }
          </div>
          {showSearch &&
            <div className='landing-banner__search'>
                <div className='landing-banner__search-select'>
                    <label>I’m looking to:</label>
                    <Select
                        value={selectedOption}
                        onChange={setSelectedOption}
                        options={options}
                        placeholder="to buy my first home"
                        className='react-select'
                        menuPlacement='top'
                        classNamePrefix='react-select'
                    />
                </div>
                <button onClick={() => handle()}>Get Started</button>
            </div>
          }
        </div>
      </Fade>
    </section>
  )
}

export default LandingBanner